import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";

class LayoutColumn extends Component {

    render() {
        const { t, column, editMode, setWidget, changeSizeColumn, deleteColumn, children } = this.props;
        const editClass = this.props.editMode ? "card p-2" : "";
        return (
            <div className={`col-md-${column.className}`}>
                { editMode ? (
                    (
                        <div className={editClass}>
                            <h5>{t('edit-column')}</h5>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('column-width-1-12')}</label>
                                        <input
                                            className="form-control"
                                            min={1}
                                            max={12}
                                            type="number"
                                            value={column.className}
                                            onChange={(e) => changeSizeColumn(this.props.column.id, e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <Button className="position-absolute-top-right" size={"sm"} variant={"danger"} onClick={(e) => deleteColumn(this.props.column.id)}>
                                <i className="fas fa-trash"/>
                            </Button>
                        </div>
                    )
                ) : (<React.Fragment/>) }

                { children }
            </div>
        );
    }
}
export default withNamespaces()(LayoutColumn);
